export default __webpack_public_path__ + "6f97a1e7f4db6ce7131401d175adc4ad.png";